import React from 'react'
import { Box, Popover, PopoverBody, PopoverContent, PopoverTrigger } from '@chakra-ui/core'

interface IProps {
  // Element the user hovers to open the popover.
  trigger: React.ReactNode
  // Popover content.
  children: React.ReactNode
  placement?: string
  minWidth?: string
  maxWidth?: string
  width?: string
  zIndex?: number
  bodyMaxHeight?: string
  // 'hover' (default) or 'click' — click also works on touch, where hover does not exist.
  openOn?: 'hover' | 'click'
  // Style overrides for the popover card itself (radius, shadow, border…).
  contentProps?: Record<string, any>
  // Opt in when the trigger sits inside a scroll container that would clip the card.
  // Off by default so existing consumers keep their current positioning.
  usePortal?: boolean
  onClose?: () => void
}

// Generic popover wrapper over Chakra's Popover — opens on hover by default, on click with
// `openOn="click"`. Accepts any trigger node and any content: reuse anywhere a small info card is
// needed (auditor lists, audience details, status composition, …) instead of wiring Chakra's
// Popover parts again.
export const HoverPopover: React.FC<IProps> = ({
  trigger,
  children,
  placement = 'top',
  minWidth = '300px',
  maxWidth = '400px',
  width = 'max-content',
  zIndex = 10003,
  bodyMaxHeight = '300px',
  openOn = 'hover',
  contentProps,
  usePortal = false,
  onClose,
}) => (
  <Popover trigger={openOn} placement={placement as any} usePortal={usePortal} onClose={onClose}>
    <PopoverTrigger>
      <Box cursor="pointer" display="inline-block">
        {trigger}
      </Box>
    </PopoverTrigger>
    <PopoverContent minW={minWidth} maxW={maxWidth} w={width} zIndex={zIndex} {...contentProps}>
      <PopoverBody p={0} maxH={bodyMaxHeight} overflowY="auto">
        {children}
      </PopoverBody>
    </PopoverContent>
  </Popover>
)
